/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMasterReservePayloadDto
 */
export interface CreateMasterReservePayloadDto {
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    indemnityMaterialDamage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    indemnityBusinessInterruption?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    underliningSirGovtProgramsSir?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    reservingComments?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    lossAdjustorCosts?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    legalExpertsCosts?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    consultantsCosts?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    otherFees?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    claimsFeesComments?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    programCessionDeclarationName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    programCessionPercent?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    captiveSirsAag?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    riSirAag?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    riCessionPercent?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    projectedUltimateLoss?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    recoveryPotential?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    recoveryActual?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMasterReservePayloadDto
     */
    recoveryComments?: string;
}

/**
 * Check if a given object implements the CreateMasterReservePayloadDto interface.
 */
export function instanceOfCreateMasterReservePayloadDto(value: object): value is CreateMasterReservePayloadDto {
    return true;
}

export function CreateMasterReservePayloadDtoFromJSON(json: any): CreateMasterReservePayloadDto {
    return CreateMasterReservePayloadDtoFromJSONTyped(json, false);
}

export function CreateMasterReservePayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMasterReservePayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'indemnityMaterialDamage': json['indemnityMaterialDamage'] == null ? undefined : json['indemnityMaterialDamage'],
        'indemnityBusinessInterruption': json['indemnityBusinessInterruption'] == null ? undefined : json['indemnityBusinessInterruption'],
        'underliningSirGovtProgramsSir': json['underliningSirGovtProgramsSir'] == null ? undefined : json['underliningSirGovtProgramsSir'],
        'reservingComments': json['reservingComments'] == null ? undefined : json['reservingComments'],
        'lossAdjustorCosts': json['lossAdjustorCosts'] == null ? undefined : json['lossAdjustorCosts'],
        'legalExpertsCosts': json['legalExpertsCosts'] == null ? undefined : json['legalExpertsCosts'],
        'consultantsCosts': json['consultantsCosts'] == null ? undefined : json['consultantsCosts'],
        'otherFees': json['otherFees'] == null ? undefined : json['otherFees'],
        'claimsFeesComments': json['claimsFeesComments'] == null ? undefined : json['claimsFeesComments'],
        'programCessionDeclarationName': json['programCessionDeclarationName'] == null ? undefined : json['programCessionDeclarationName'],
        'programCessionPercent': json['programCessionPercent'] == null ? undefined : json['programCessionPercent'],
        'captiveSirsAag': json['captiveSirsAag'] == null ? undefined : json['captiveSirsAag'],
        'riSirAag': json['riSirAag'] == null ? undefined : json['riSirAag'],
        'riCessionPercent': json['riCessionPercent'] == null ? undefined : json['riCessionPercent'],
        'projectedUltimateLoss': json['projectedUltimateLoss'] == null ? undefined : json['projectedUltimateLoss'],
        'recoveryPotential': json['recoveryPotential'] == null ? undefined : json['recoveryPotential'],
        'recoveryActual': json['recoveryActual'] == null ? undefined : json['recoveryActual'],
        'recoveryComments': json['recoveryComments'] == null ? undefined : json['recoveryComments'],
    };
}

export function CreateMasterReservePayloadDtoToJSON(json: any): CreateMasterReservePayloadDto {
    return CreateMasterReservePayloadDtoToJSONTyped(json, false);
}

export function CreateMasterReservePayloadDtoToJSONTyped(value?: CreateMasterReservePayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'indemnityMaterialDamage': value['indemnityMaterialDamage'],
        'indemnityBusinessInterruption': value['indemnityBusinessInterruption'],
        'underliningSirGovtProgramsSir': value['underliningSirGovtProgramsSir'],
        'reservingComments': value['reservingComments'],
        'lossAdjustorCosts': value['lossAdjustorCosts'],
        'legalExpertsCosts': value['legalExpertsCosts'],
        'consultantsCosts': value['consultantsCosts'],
        'otherFees': value['otherFees'],
        'claimsFeesComments': value['claimsFeesComments'],
        'programCessionDeclarationName': value['programCessionDeclarationName'],
        'programCessionPercent': value['programCessionPercent'],
        'captiveSirsAag': value['captiveSirsAag'],
        'riSirAag': value['riSirAag'],
        'riCessionPercent': value['riCessionPercent'],
        'projectedUltimateLoss': value['projectedUltimateLoss'],
        'recoveryPotential': value['recoveryPotential'],
        'recoveryActual': value['recoveryActual'],
        'recoveryComments': value['recoveryComments'],
    };
}

